import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from 'react-router-dom';
import { PlaylistAssignmentsForPortal, PlaylistAssignmentsPortals } from '..';
import { Route } from '../../routing';
import { PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT } from '../../../constants/Navigation';

const PlaylistAssignmentsMonitoringRoutes = ({
  playlistId
}) => {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT,
      children: /*#__PURE__*/_jsx(PlaylistAssignmentsForPortal, {
        playlistId: playlistId
      })
    }), /*#__PURE__*/_jsx(Route, {
      children: /*#__PURE__*/_jsx(PlaylistAssignmentsPortals, {
        playlistId: playlistId
      })
    })]
  });
};

export default PlaylistAssignmentsMonitoringRoutes;